import { getParam, isSafari, isiOS } from "@needle-tools/engine";
import { isMobileDevice } from "@needle-tools/engine";

export class Utility {
  //create singleton instance

  public static getDistanceBetweenTwoPoints(
    x1: number,
    y1: number,
    x2: number,
    y2: number,
  ): number {
    let xDistance = x2 - x1;
    let yDistance = y2 - y1;
    return Math.sqrt(Math.pow(xDistance, 2) + Math.pow(yDistance, 2));
  }

  public static userUsingMobileDevice(): boolean {
    if (isMobileDevice() == true) {
      return true;
    } else {
      return false;
    }
  }

  public static userUsingiOS(): boolean {
    if (isiOS() == true) {
      return true;
    } else {
      return false;
    }
  }

  public static userUsingSafari(): boolean {
    if (isSafari() == true) {
      return true;
    } else {
      return false;
    }
  }

  public static returnRandomNumber(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  public static returnRandomFloat(min: number, max: number): number {
    // Ensure that max is greater than min
    if (min > max) {
      throw new Error("Invalid range: min should be less than max");
    }

    let randomValue = Math.random() * (max - min) + min;

    // Safeguard to ensure the value is within the expected range
    if (randomValue < min) randomValue = min;
    if (randomValue > max) randomValue = max;

    return randomValue;
  }

  private static getAppleOSVersion(userAgent: string): string | null {
    const match = userAgent.match(/CPU OS (\d+_\d+)/);
    return match ? match[1] : null;
  }

  private static isAppleOSOlderThan16(osVersion: string): boolean {
    const [major, minor] = osVersion.split("_").map(Number);
    return major < 16 || (major === 16 && minor === 0);
  }

  public static determineUserDeviceSettings(userAgent: string): void {
    if (this.userUsingMobileDevice()) {
      console.log("User is using a mobile device");

      if (
        userAgent.includes("iPhone") ||
        userAgent.includes("iPad") ||
        userAgent.includes("iPod")
      ) {
        console.log("User is using an Apple mobile device");

        const osVersion = this.getAppleOSVersion(userAgent);
        if (osVersion && this.isAppleOSOlderThan16(osVersion)) {
          console.log("Apple device has OS older than 16.0.0");
        } else {
          console.log("Apple device has OS 16.0.0 or newer");
        }

        if (userAgent.includes("iPad")) {
          console.log("User is using an iPad");
        } else if (userAgent.includes("iPhone") || userAgent.includes("iPod")) {
          console.log("User is using an iPhone or iPod");
        }
      } else if (userAgent.includes("Android")) {
        console.log("User is using an Android device");
        // Add additional checks for Android devices if needed
      }
    }
  }

  public static getUserAgent(): string {
    const userAgent = navigator.userAgent;
    Utility.determineUserDeviceSettings(userAgent);
    return userAgent;
    //this.uiManager?.updateUserAgentText(userAgent);
  }
}
